import { create } from 'zustand';
import { persist } from 'zustand/middleware';

/** Default trailer loading-metres capacity for a new load. */
export const DEFAULT_LOADING_METRES = 13.4;

/** Single-select leg-type quick filter. null = no filter (show all). */
export type LegFilter = 'Collect' | 'Trunk' | 'Deliver' | 'Direct';

interface ManifestViewState {
  /** Selected depot (an organisation site / location id) — null = all depots. */
  depotId: string | null;
  /** Additional days beyond today included in the horizon (0 = today only). */
  horizonDays: number;
  /** Default loading metres applied to new loads / the capacity gauge. */
  defaultLm: number;
  /** Active leg-type filter, or null for none. */
  legFilter: LegFilter | null;
  setDepot: (id: string | null) => void;
  setHorizonDays: (days: number) => void;
  setDefaultLm: (lm: number) => void;
  setLegFilter: (f: LegFilter | null) => void;
}

/**
 * Toolbar / view state for the Manifesting board — depot, horizon and the
 * default loading metres. Persisted (survives tab switches and reloads) so an
 * operator returns to the same depot + horizon they were planning.
 */
export const useManifestViewStore = create<ManifestViewState>()(
  persist(
    (set) => ({
      depotId: null,
      horizonDays: 0,
      defaultLm: DEFAULT_LOADING_METRES,
      legFilter: null,
      setDepot: (id) => set({ depotId: id }),
      setHorizonDays: (days) => set({ horizonDays: days }),
      setDefaultLm: (lm) => set({ defaultLm: lm }),
      setLegFilter: (f) => set({ legFilter: f }),
    }),
    { name: 'my:tms:manifestView' },
  ),
);
